<div class="overview ov">
  <!-- Send readiness: what happens when "Add" is pressed -->
  <section class="ov__ready" aria-labelledby="ov-ready-title">
    <p class="bk-eyebrow">Ready to add</p>
    <p class="ov__figure" id="ov-ready-title">
      {{ formatCount(ready) }}
      <span class="ov__unit">{{ ready === 1 ? 'number' : 'numbers' }} will be added</span>
    </p>

    <ul class="ov__rows">
      @if (invalid > 0) {
      <li class="ov__row">
        <app-status [text]="formatCount(invalid) + ' invalid, will be skipped'" status="failed" />
        <span class="ov__row-actions">
          <button type="button" class="bk-more" (click)="showTab.emit('invalids')">Edit them here</button>
          <button type="button" class="bk-btn bk-btn--ghost ov__download" (click)="downloadInvalids()">
            <span class="bk-sym" aria-hidden="true">download</span>
            Download invalid numbers
          </button>
        </span>
      </li>
      } @else {
      <li class="ov__row">
        <app-status text="Every number is valid" status="success" />
      </li>
      }

      @if (repeatedNumbers > 0) {
      <li class="ov__row">
        <span class="ov__label">
          <app-status
            [text]="formatCount(repeatedNumbers) + (repeatedNumbers === 1 ? ' repeated number' : ' repeated numbers')"
            status="pending"
          />
          <span class="ov__detail">{{ formatCount(repeatedRows) }} extra {{ repeatedRows === 1 ? 'row' : 'rows' }} in the file</span>
        </span>
        <button type="button" class="bk-more" (click)="showTab.emit('duplicated')">See repeats</button>
      </li>
      }

      @if (removed > 0) {
      <li class="ov__row">
        <app-status [text]="formatCount(removed) + ' removed by you'" status="cancelled" />
        <button type="button" class="bk-more" (click)="showTab.emit('removed')">See removed</button>
      </li>
      }

      @if (edited > 0) {
      <li class="ov__row">
        <app-status [text]="formatCount(edited) + ' edited by you'" status="cancelled" />
        <button type="button" class="bk-more" (click)="showTab.emit('updated')">See edits</button>
      </li>
      }
    </ul>
  </section>

  <!-- The file itself -->
  <section class="ov__file" aria-label="File">
    <p class="bk-eyebrow">File</p>
    <dl class="bk-kv ov__kv">
      <dt>Name</dt>
      <dd>{{ localCSVService.getFileName || '—' }}</dd>
      <dt>Size</dt>
      <dd>{{ localCSVService.getFileSize }}</dd>
      <dt>Rows read</dt>
      <dd>{{ formatCount(localCSVService.getFormattedFileDataCount) }}</dd>
      <dt>Read numbers as</dt>
      <dd>{{ countryLabel }}</dd>
    </dl>
  </section>
</div>
